import { useState, useCallback, useRef } from 'react'
import { calcTooltipItems } from '@aytm/app/stats/page/question-views/hm/components/chart/components/lasso/lib/utils'

export const useLassoTooltip = ({ answer, imageH, scale }) => {
  const [tooltip, setTooltip] = useState(null)

  const answerRef = useRef(answer)
  const imageHRef = useRef(imageH)
  const scaleRef = useRef(scale)

  answerRef.current = answer
  imageHRef.current = imageH
  scaleRef.current = scale

  const showTooltip = useCallback((coords, polygonPoints) => {
    if (polygonPoints.length < 3) {
      setTooltip(null)
      return
    }

    const items = calcTooltipItems(polygonPoints, scaleRef.current, imageHRef.current, answerRef.current)
    setTooltip({ x: coords[0] + 12, y: coords[1] + 5, items })
  }, [])

  const hideTooltip = useCallback(() => setTooltip(null), [])

  return { tooltip, showTooltip, hideTooltip }
}
